import { Info } from "luxon";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

// AdapterLuxon with weeks that start on Sunday instead of Monday.
export class AdapterLuxonSunday extends AdapterLuxon {
  // Luxon weekday: 1 = Monday ... 7 = Sunday, so (weekday % 7) = days since Sunday
  startOfWeek = (value) =>
    value.startOf("day").minus({ days: value.weekday % 7 });

  endOfWeek = (value) =>
    this.startOfWeek(value).plus({ days: 6 }).endOf("day");

  // Day-of-week header labels, Sunday first
  getWeekdays = () => {
    const days = Info.weekdaysFormat("narrow", { locale: this.locale });
    return [days[days.length - 1], ...days.slice(0, -1)];
  };

  // Grid of weeks for the month view, Sunday first
  getWeekArray = (value) => {
    const start = this.startOfWeek(value.startOf("month"));
    const end = this.endOfWeek(value.endOf("month"));

    const weeks = [];
    let current = start;

    while (current <= end) {
      const week = [];
      for (let i = 0; i < 7; i += 1) {
        week.push(current);
        current = current.plus({ days: 1 });
      }
      weeks.push(week);
    }

    return weeks;
  };
}